import * as React from "react";
import { useTheme } from "@mui/material/styles";
import WDUnitController from "../../controllers/WDUnitController";
import { Unit } from "../../../utils/map/getUnits";
import UIState from "../../../enums/UIState";
import { getUnitSize } from "../../../map/variants";

export const UNIT_HEIGHT = 75;
export const UNIT_WIDTH = 75;

interface WDUnitProps {
  id: string | undefined;
  unit: Unit;
  unitState: UIState;
}

const WDUnit: React.FC<WDUnitProps> = function ({
  id,
  unit,
  unitState,
}): React.ReactElement {
  const theme = useTheme();
  const unitSize = getUnitSize();
  return (
    <g
      filter={theme.palette.svg.filters.dropShadows[1]}
      height={unitSize}
      id={id}
      width={unitSize}
      style={{ overflow: "visible" }}
    >
      <WDUnitController
        unit={unit}
        unitState={unitState}
        unitWidth={unitSize}
        unitHeight={unitSize}
      />
    </g>
  );
};

export default WDUnit;
